'use client';

import React from 'react';
import { useModal } from '@/contexts/ModalContext';
import TeamNoteSwitchModal from '@/components/footballlogs/TeamNoteSwitchModal';

interface TeamNoteSwitcherProps {
  propsTeamNoteTeamUUID: string;
  onChange: (value: string) => void;
}

const TeamNoteSwitcher: React.FC<TeamNoteSwitcherProps> = ({ propsTeamNoteTeamUUID, onChange }) => {
  /**
   * react context
   */
  const { openModal } = useModal();

  const handleOpenTeamNoteSwitchModal = () => {
    openModal(<TeamNoteSwitchModal propsSelectedValue={propsTeamNoteTeamUUID} onChange={onChange} />);
  };

  return (
    <div>
      <button
        className="h-8 bg-white border border-gray-300 hover:bg-gray-100 rounded-lg px-4 py-2 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700"
        type="button"
        onClick={handleOpenTeamNoteSwitchModal}>
        <svg
          className="w-4 h-4"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24">
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 20a16.405 16.405 0 0 1-5.092-5.804A16.694 16.694 0 0 1 5 6.666L12 4l7 2.667a16.695 16.695 0 0 1-1.908 7.529A16.406 16.406 0 0 1 12 20Z"
          />
        </svg>
      </button>
    </div>
  );
};

export default TeamNoteSwitcher;
